import React from 'react';
import classnames from 'classnames';
import { Field, getIn } from 'formik';
import './RadioButton.scss';

class RadioButton extends React.Component {
  render() {
    const { name, value, form, childTop, ...props } = this.props;

    const wrapperClass = classnames({
      'form-check form-radio': true
    });

    const labelClass = classnames({
      'form-check-label': true
    });

    const checkboxClass = classnames({
      'form-check-input': true
    });

    return (
      <Field name={name}>
        {({ field, form: { touched, errors } }) => (
          <div className={wrapperClass}>
            <label className={labelClass}>
              <input
                {...field}
                {...props}
                type="radio"
                value={value}
                className={checkboxClass}
              />
              <span>
                <i className="far fa-circle"></i> {this.props.text}
              </span>
            </label>
          </div>
        )}
      </Field>
    );
  }
}

export default RadioButton;
